import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import updateOrCreatePatientConsent from '../../graphql/mutations/updateOrCreatePatientConsent.graphql';
import styles from './styles.module.scss';
import SaveButton from '../SaveButton';
import CancelButton from '../CancelButton';
import Error from '../Error';
 
const EditPatientConsent = ({ memberId, onHandleButtonClick, consent, approvalResponseFlag }) => {
  const [patientConsent, setPatientConsent] = useState(consent);
  const [flag, setFlag] = useState(approvalResponseFlag);

  const [updateOrCreateConsent, { error }] = useMutation(updateOrCreatePatientConsent, {
    variables: { memberId: memberId, approvalResponseFlag: flag },
    refetchQueries: [
      'tasFetchPatientConsent'
    ]
  });

  if (error) return <Error />;

  const onHandleSaveButtonClick = () => {
    updateOrCreateConsent();
    onHandleButtonClick();
  };

  const handleCheckBoxChange = () => {
    if (patientConsent) {
      setPatientConsent(false);
      setFlag('N');
    } else {
      setPatientConsent(true);
      setFlag('Y');
    }
  };
  
  return (
    <div>
      <form className={styles.editPatientConsentForm}>
        <div className={styles.editPatientConsentFormInput}>
          <label>
            <input type="checkbox" 
                  className={styles.editPatientConsentFormCheckbox} 
                  checked={patientConsent} 
                  onChange={handleCheckBoxChange} 
            />
            Allow Teladoc providers and your existing doctors to share records with each other
          </label>
        </div>
        <div className={styles.editPatientConsentFormButtons}>
          <CancelButton onHandleClick={onHandleButtonClick} />
          <SaveButton onHandleSaveClick={onHandleSaveButtonClick} />
        </div>
      </form>
    </div>
  )
}

export default EditPatientConsent;